import { IdTokenClaims } from 'oidc-client-ts';

type ViatelTokenClaims = IdTokenClaims & {
  company_id: string | undefined;
  has_multiple_users?: boolean;
  issued_at?: string;
  role?: string;
};

export const isViatelProfile = (profile: IdTokenClaims | undefined): profile is ViatelTokenClaims => {
  return !!profile && 'company_id' in profile;
};

const isViatelAdmin = (role: string | undefined) => role === 'viateladmin';

export const canChangeCompany = (profile: IdTokenClaims | undefined): boolean => {
  if (isViatelProfile(profile)) {
    return isViatelAdmin(profile.role) || !!profile.has_multiple_users;
  }
  return false;
};
